<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-file-contract me-2"></i>
    {{ 'companyProfile.billing.feeAcceptance.title' | translate }}
  </h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="fee-intro mb-4">
    <p class="text-muted">{{ 'companyProfile.billing.feeAcceptance.intro' | translate }}</p>
  </div>

  <!-- Fee Cards -->
  <div class="row g-3 mb-4">
    <!-- HorseLoop Platform Fee -->
    <div class="col-md-6">
      <div class="fee-card">
        <div class="fee-icon platform">
          <i class="fa fa-horse-head"></i>
        </div>
        <div class="fee-details">
          <h6>{{ 'companyProfile.billing.platformFeeTitle' | translate }}</h6>
          <div class="fee-rate">2%</div>
          <p class="text-muted mb-0 small">{{ 'companyProfile.billing.platformFeeDesc' | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Stripe Transaction Fee -->
    <div class="col-md-6">
      <div class="fee-card">
        <div class="fee-icon stripe">
          <i class="fab fa-stripe-s"></i>
        </div>
        <div class="fee-details">
          <h6>{{ 'companyProfile.billing.stripeFeeTitle' | translate }}</h6>
          <div class="fee-rate">1.5% + 2 kr</div>
          <p class="text-muted mb-0 small">{{ 'companyProfile.billing.stripeFeeDesc' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Additional Info -->
  <div class="alert alert-light mb-4">
    <div class="d-flex">
      <i class="fa fa-info-circle text-muted me-3 mt-1"></i>
      <small class="text-muted">{{ 'companyProfile.billing.feeNote' | translate }}</small>
    </div>
  </div>

  <!-- Acceptance Checkbox -->
  <div class="acceptance-section">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="acceptFees"
        [(ngModel)]="accepted"
      />
      <label class="form-check-label" for="acceptFees">
        {{ 'companyProfile.billing.feeAcceptance.checkbox' | translate }}
      </label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">
    {{ 'common.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!accepted"
    (click)="confirm()"
  >
    <i class="fab fa-stripe me-2"></i>
    {{ 'companyProfile.billing.feeAcceptance.confirm' | translate }}
  </button>
</div>
